export default "__VITE_ASSET__62ae582e__"